/**
 * CSP Nonce utility.
 *
 * Reads the per-request nonce that nginx injects into
 * <meta name="csp-nonce" content="<nonce>"> at serve time.
 *
 * Used by Emotion (MUI v5 styled engine) and JSS (@mui/styles)
 * so every runtime-injected <style> tag carries the correct nonce
 * attribute, satisfying strict Content-Security-Policy headers.
 */
const meta = document.querySelector('meta[name="csp-nonce"]');
const raw = meta?.getAttribute('content') ?? '';

// Detect unreplaced placeholder in production — means nginx sub_filter didn't run.
// This is a silent, critical security failure: the nonce is static and public,
// making the entire CSP nonce scheme ineffective.
// In dev mode (Vite dev server), nginx isn't involved so the placeholder is expected.
if (import.meta.env.PROD && (raw === '__CSP_NONCE__' || raw === '')) {
  console.error(
    '[CSP] Nonce placeholder was not replaced by nginx. ' +
      'CSP nonce protection is NOT active. ' +
      'Check that sub_filter is configured and nginx is serving this page.'
  );
}

export const cspNonce = raw;
